goog.provide("shadow.js.shim.module$$mui$material$TableRow$default");
shadow.js.shim.module$$mui$material$TableRow$default = shadow.js.shim.module$$mui$material$TableRow.default;
